export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7787.b4471c70.jpg";